import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import PdfHistoricoPersonaService from '../pdf/PdfHistoricoPersona.service';
import AlertService from '@/shared/alert/alert.service';
import { Expediente } from '@conacyt/historicopersonasms-client';
import VisualizadorPdfComponent from '@/components/visualizador-pdf/visualizador-pdf.vue';

@Component({
  components: {
    'visualizador-pdf': VisualizadorPdfComponent,
  },
})
export default class HistoryItemComponent extends Vue {
  @Inject('pdfHistoricoPersonaService') private readonly pdfHistoricoPersonaService: () => PdfHistoricoPersonaService;
  @Inject('alertService') private readonly alertService: () => AlertService;

  @Prop({ required: true })
  public items!: any[];

  @Prop({ required: false })
  public noTieneAdeudo!: boolean;

  @Prop({ required: false })
  public expediente!: Expediente;

  @Prop({ required: false })
  public fields!: any[];

  filter = null;
  filterOn = [];
  currentPage = 1;
  perPage = 100;
  totalRows = 0;
  selected = [];
  originalSelected = [];

  public pdfReady = false;
  public contenidoBase64 = '';
  public showPdf = false;

  mounted() {
    this.expediente;
    if (this.items?.length) {
      this.totalRows = this.items.length;
    }
  }
  get totalSelectedRows() {
    if (this.selected?.length) {
      return this.selected.length;
    }
    return 0;
  }

  public onFiltered(filteredItems) {
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  get jsonExcel() {
    const rows = [];
    if (this.fields?.length > 0 && this.items?.length > 0) {
      for (const item of this.items) {
        rows.push(this.createRow(item));
      }
    }
    return rows;
  }

  createRow(item) {
    const currentRow = {};
    for (const field of this.fields) {
      const formatter = this.resolveFormatter(field.key);
      currentRow[field.label] = formatter(this.resolveValue(field.key, item), field.key, item);
    }
    return currentRow;
  }

  resolveValue(key: string, field) {
    const paths = key.split('.');
    let currentValue = field;
    for (const path of paths) {
      currentValue = currentValue ?? [path];
    }
    return currentValue;
  }

  resolveFormatter(key: string) {
    const field = this.fields.find(field => field.key === key);
    if (field.formatter) {
      return field.formatter;
    }
    // se regresa una formateador que sólo regresa el valor sin modificarlo
    return value => value;
  }

  public async generarPdfConstanciaNoAdeudos() {
    try {
      this.showPdf = true; //Activa overlay
      this.pdfReady = false;
      const responseDocumento = await this.pdfHistoricoPersonaService().exportarPdfConstanciaNoAdeudo(this.expediente);
      this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
      this.showPdf = false;
      this.pdfReady = true;
    } catch (error) {
      this.showPdf = false;
      this.alertService().showError(this, this.$t(error.response.data.detail, 'Error al generar vista previa documento').toString());
      return Promise.reject(error);
    }
  }
}
